import React from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';

function MyStatsControl() {
  const theme = useTheme();

  return (
    <Grid
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'column'}
      height={'100%'}
      width={'100%'}
    >
      <Typography variant='h4' textAlign={'center'} sx={{ textWrap: 'wrap', marginBottom: '2rem' }}>
        <span style={{color: `${theme.palette.primary.main}`}}>My Stats</span> Coming At Launch!
      </Typography>
      <BarChartOutlinedIcon 
        height={50}
        width={50}
        variant='contained'
        sx={{ 
          color: `${theme.palette.primary.main}`,
          backgroundColor: `${theme.palette.secondary.main}`,
          marginRight: '1rem',
          fontSize: '7rem'
        }}
      />
      <Typography textAlign={'center'} sx={{ padding: '1rem'}}>
        Once we fully launch the app, here you'll be able to see how users are interacting with your 
        recipes and videos, determining your overall payout of the total app profits each month!
      </Typography>
    </Grid>
  )
}

export default MyStatsControl;